import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const Cover = styled.div`
  height: fit-content;
  background: url(${({ src }) => getUrlWithToken(src)});
  background-position: center center;
  background-size: cover;
  color: ${(props) => props.theme.colors.white};
`;

export const Overlay = styled.div`
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.67) 15.31%,
    rgba(104, 104, 104, 0) 103.19%
  );
  width: 100%;
  height: inherit;
  padding-bottom: 60px;

  @media ${(props) => props.theme.device.tablet} {
    padding-bottom: 32px;
  }
`;

export const Gradient = styled.div`
  padding: 53px 0 43px;
  background: linear-gradient(
    81.9deg,
    rgba(13, 69, 135, 0.122) -2.96%,
    rgba(0, 71, 146, 0) 131.46%
  );

  @media ${(props) => props.theme.device.tablet} {
    padding: 32px 16px;
  }

  .logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 80px;
    @media ${(props) => props.theme.device.tablet} {
      padding: 0;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
`;

export const LogoCard = styled.div`
  width: 174px;
  height: 174px;
  box-shadow: 4px 6px 60px rgba(4, 86, 179, 0.1);
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;

  @media ${(props) => props.theme.device.tablet} {
    width: calc(50% - 5px);
  }
`;

export const LogoImg = styled.img`
  height: 75px;
  width: auto;
`;

export const LogoLink = styled.a`
  text-align: center;
  cursor: pointer;
  text-decoration: none !important;
  outline: none !important;
  transition: 0.3s all ease;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.theme.colors.link};

  &:hover {
    color: ${(props) => props.theme.colors.btnHover};
    svg {
      stroke: ${(props) => props.theme.colors.btnHover};
    }
  }
`;
